const NOTIFICATION_TYPES = {
    TOAST: 'Toast Notification',
    STICKY: 'Sticky Notification',
};

export default NOTIFICATION_TYPES;
